import {makeStyles} from "@material-ui/core";

export const useStyles = makeStyles(theme => ({
    logo: {
        marginRight: theme.spacing(2),
        cursor: 'pointer',
        height: 30,
    }
}));